import first from 'lodash/first';
import React from 'react';
import PropTypes from 'prop-types';
import TreeViewListItem from './TreeViewListItem';
import './TreeViewList.scss';

function TreeViewList(props) {
  const { taxonomies, onSelect, onToggle, showCountIndicator, ariaLabel } = props;

  const getMaxLineOfCount = () => {
    if (!taxonomies) {
      return null;
    }
    if (!taxonomies.length) {
      return 0;
    }
    const hitCount = first(taxonomies)?.hitCount;
    return typeof hitCount === 'number' ? hitCount : 0;
  };

  // Only render root-level items here. Children are rendered recursively
  // inside their parent's TreeViewListItem, building the real DOM hierarchy.
  const rootTaxonomies = taxonomies.filter((taxonomy) => taxonomy.visible && (!taxonomy.parents || taxonomy.parents?.length === 0));

  return (
    <ul role="tree" aria-multiselectable="true" aria-label={ariaLabel || 'Tree view'} className="treeViewList">
      {rootTaxonomies.map((taxonomy) => (
        <TreeViewListItem
          key={`taxonomy-${taxonomy.id}-${taxonomy.name}`}
          onToggle={onToggle}
          onSelect={onSelect}
          taxonomy={taxonomy}
          maxLineOfCount={getMaxLineOfCount()}
          showCountIndicator={showCountIndicator}
        />
      ))}
    </ul>
  );
}

TreeViewList.propTypes = {
  showCountIndicator: PropTypes.bool,
  taxonomies: PropTypes.array,
  onSelect: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
};

export default TreeViewList;
